import React from "react";
import { Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { useLocale } from "@/middleware";
import { useTranslate } from "@/locales";

interface ProductCardProps {
  item: any;
  onDelete: (id: string) => void;
  onView: (id: string) => void;
}

const ProductCard: React.FC<ProductCardProps> = ({
  item,
  onDelete,
  onView,
}) => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  return (
    <div className="bg-white relative shadow-md rounded-2xl flex flex-col items-start">
      <img
        src={
          item.image
            ? item.image.url
            : item.imagePreview
            ? item.imagePreview
            : "https://via.placeholder.com/150"
        }
        alt={item.name}
        className="w-full border-b rounded-t-2xl h-64 object-cover"
      />
      <div className="px-4 mt-2 w-full">
        <h3 className="text-lg font-bold mb-2">{item.name}</h3>
        <p className="text-sm text-gray-600 mb-2">
          {item.description || "No description"}
        </p>
        <div className="flex justify-between">
          <p className="text-sm flex gap-2 mb-2">
            <div className="font-semibold"> {t("item.fields.type")}:</div>{" "}
            {item.type}
          </p>
          <p className="text-sm flex gap-2 mb-2">
            <div className="font-semibold">{t("item.fields.stock")}:</div>{" "}
            {item.stock}
          </p>
        </div>
      </div>
      <p className="w-full text-center p-4 text-xl flex gap-2 mb-2">
        <div className="font-semibold">{t("item.fields.price")}:</div>
        {item.price.toFixed(2)} SAR
      </p>
      <div className="flex px-3 pb-2 justify-between w-full">
        <Tooltip title="View Details">
          <EditIcon
            style={{
              color: "#000",
              border: "1px solid #000",
              borderRadius: 8,
              padding: "4px",
              fontSize: 28,
            }}
            className="cursor-pointer !text-4xl text-blue-500"
            onClick={() => onView(item.id)}
          />
        </Tooltip>
        <Tooltip title="Delete Item">
          <DeleteIcon
            style={{
              border: "1px solid red",
              borderRadius: 8,
              padding: "4px",
              fontSize: 28,
            }}
            className="cursor-pointer !text-4xl text-red-500"
            onClick={() => onDelete(item.id)}
          />
        </Tooltip>
      </div>
    </div>
  );
};

export default ProductCard;
